export default {
  styleOverrides: {
    root: {
      "& .MuiInputBase-input": {
        zIndex: 10
      }
    }
  }
};
